<ion-list>
  <ion-item button="true" lines="none" (click)="onLangBtnCLicked('en-US')">
    <!-- <ion-icon name="flag-outline" item-left></ion-icon> -->
    <ion-img class="flag" src="./../../assets/images/flags/en-US.png"></ion-img>
    <ion-label>English</ion-label>
  </ion-item>
  <ion-item button="true" lines="none" (click)="onLangBtnCLicked('pt-BR')"> 
    <!-- <ion-icon name="flag-outline" item-left></ion-icon> -->
    <ion-img class="flag" src="./../../assets/images/flags/pt-BR.png"></ion-img>
    <ion-label>Português</ion-label>
  </ion-item>
</ion-list>
